{
  "__comment.error.app": "Errores generados en la aplicación - weblate: copia y pega sin traducir esta línea",
  "__comment.error.backend": "Errores generados desde el backend - weblate: copiar y pegar sin traducir esta línea",
  "admin.unauthorized": "No tienes autorización para realizar esta acción",
  "anonymous.request": "Se ha producido un error. Si el problema persiste, contáctanos",
  "app-service.not-connected": "Parece que no estás conectado a Internet.",
  "app-service.unavailable.description": "Un problema de conexión impide el acceso al servicio. Por favor, verifica tu conexión a Internet.",
  "app.accessibility.community": "Página de comunidades",
  "app.accessibility.intentions": "Página de intenciones",
  "app.accessibility.intentions-theme": "Página de intenciones temáticas",
  "app.accessibility.messages": "Página de mensajes",
  "app.accessibility.unsubscribe-donation-mail": "Página para cancelar la suscripción a correos de donaciones",
  "app.audio.listen": "Reproducir el audio",
  "app.audio.loading-error": "Se ha producido un error al cargar el archivo de audio",
  "app.avoidance-navigation.content": "Contenido de página",
  "app.banner.goal.goal": "Objetivo: {amount} donaciones regulares",
  "app.description": "¡Gracias a la <strong>aplicación Hozana</strong>, accede con un clic a tu rincón de oración, descubre nuevas comunidades y deja tus intenciones dondequiera que estés!",
  "app.discover": "Descubrir nuestras propuestas",
  "app.donation.later.i-want": "Recibir un recordatorio",
  "app.donation.later.success.toast": "Recibirá un recordatorio en unos días",
  "app.download": "Descargar la aplicación",
  "app.error": "Oops, an error occurred, please try again later.",
  "app.how-to.open-menu": "Menú: para abrir el menú lateral pulse Enter, para cerrar el menú pulse Esc",
  "app.i-donate": "Hago un don",
  "app.maintenance": "<strong>Hozana</strong> está en mantenimiento.\nEspera unos minutos antes de actualizar el navegador para continuar.",
  "app.navigation.events-link": "¡Los eventos de Hozana!",
  "app.navigation.footer.faq.link": "¡Preguntas... y respuestas!",
  "app.navigation.footer.guide.all": "Todos los artículos de nuestras guías",
  "app.navigation.footer.guide.bible": "Descubra la Biblia",
  "app.navigation.footer.guide.catechism": "Catecismo: ¡respuestas a tus preguntas!",
  "app.navigation.footer.guide.feast-days": "Fiestas cristianas",
  "app.navigation.footer.guide.meditation": "Guía de meditación cristiana",
  "app.navigation.footer.guide.miracles": "Descubre los milagros y apariciones",
  "app.navigation.footer.guide.prayer": "Consejos para orar",
  "app.navigation.footer.guide.rosary": "Guía para rezar el Rosario",
  "app.navigation.footer.guide.saints": "Descubrir los santos",
  "app.navigation.footer.who.we.are.link": "¿Quiénes somos?",
  "app.navigation.jobs-link": "Ofertas de empleo !",
  "app.navigation.main": "Menú principal",
  "app.navigation.open-menu": "Abrir menú",
  "app.navigation.secondary": "Menú secundario",
  "app.report-abuse.comment": "Reportar este comentario",
  "app.report-abuse.comment.success": "Este comentario ha sido reportado, ¡gracias por tu ayuda!",
  "app.report-abuse.intention": "Denunciar esta intención",
  "app.report-abuse.intention.success": "La intención ha sido reportada, ¡gracias por tu ayuda!",
  "app.report-abuse.placeholder": "Estoy reportando este contenido porque…",
  "app.report-abuse.reason": "Díganos a continuación por qué desea denunciar este contenido.",
  "app.report-abuse.report": "Señalar un abuso",
  "app.report-abuse.send": "Señalar",
  "app.report-abuse.uplift": "Denunciar este mensaje de apoyo",
  "app.report-abuse.uplift.success": "Este mensaje ha sido reportado, ¡gracias por tu ayuda!",
  "app.report-issue.button": "Informar de un problema",
  "app.report-issue.thank-you": "¡Gracias! Tu problema ha sido reportado correctamente",
  "auth.complete.choose-password": "Elige una contraseña<br/>para completar tu inscripción en Hozana",
  "auth.complete.not-my-email": "Esta no es mi dirección de correo electrónico",
  "auth.login.email": "Iniciar sesión con email",
  "auth.login.login": "Conectarse",
  "auth.login.welcome": "Te damos la bienvenida",
  "auth.otp.code.accessibility-label": "Código de autenticación de seis dígitos",
  "auth.otp.code.description": "Hemos enviado un código temporal a: {email}",
  "auth.otp.code.resend": "Reenviar el código",
  "auth.otp.code.title": "Revisa tu email",
  "auth.otp.login.title": "¿Cuál es tu dirección de email?",
  "auth.otp.signup.title": "¿Cómo te llamas?",
  "auth.privacy.notice": "Hozana es gratuito. Estas son las <link>condiciones generales</link>. Hozana nunca compartirá tu dirección de email con terceros sin tu consentimiento.",
  "auth.signup.signup": "Inscribirse",
  "auth.social.apple": "Iniciar sesión con Apple",
  "auth.social.apple.missing-identity-token": "El inicio de sesión con Apple no devolvió un token de identidad",
  "auth.social.google": "Continuar con Google",
  "auth.social.google.canceled": "Se canceló el inicio de sesión con Google",
  "auth.social.google.missing-authorization-code": "El inicio de sesión con Google no devolvió un código de autorización",
  "birthdate.invalid": "La fecha de nacimiento no es válida",
  "captcha.invalid": "El test del detector de robot ha fallado, intenta de nuevo",
  "captcha.missing": "Por favor elije \"No soy un robot\"",
  "captcha.required": "Por favor haz esta pequeña prueba de identificación",
  "comment.community.unknown": "Comunidad desconocida",
  "comment.delete.delete": "Eliminar comentario",
  "comment.delete.fail.none": "El comentario no pudo ser eliminado",
  "comment.delete.not.found": "No pudimos encontrar el comentario que deseas eliminar",
  "comment.form.empty": "Escribe un comentario para publicar",
  "comment.from": "Comentario de {contactName}",
  "comment.id.not-found": "Vaya, no pudimos mostrar las respuestas a este comentario",
  "comment.not-found": "Comentario no encontrado",
  "comment.relative.time": "{prefix} {time}",
  "comment.relative.time.today": "Hoy a las {time}",
  "comment.relative.time.week-day": "{weekday} a las {time}",
  "comment.relative.time.yesterday": "Ayer a las {time}",
  "comment.relative.week-day": "{weekday}",
  "comment.update.not.found": "No pudimos encontrar el comentario que deseas actualizar",
  "comment.write.your-comment": "Su comentario",
  "common.error.api.default": "Problema de conexión con el servidor",
  "common.error.unknown": "Ha ocurrido un error",
  "common.form.error.captcha.invalid": "El captcha no es válido. Vuelva a intentarlo.",
  "common.form.error.captcha.required": "Marque \" No soy un robot \"",
  "common.form.error.email.invalid": "Dirección de correo electrónico no válida",
  "common.form.error.fail": "Error desconocido, por favor inténtalo de nuevo",
  "common.form.error.field.invalid": "Campo no válido, favor corregir",
  "common.form.error.field.required": "Por favor, completa este campo",
  "common.form.error.message.required": "Mensaje requerido",
  "common.form.error.password-is-name": "Su contraseña debe ser diferente a su nombre",
  "common.form.error.password.different": "Por favor, confirma con la misma contraseña",
  "common.form.error.subject.required": "Asunto obligatorio",
  "common.word.start-today": "Comienza hoy",
  "common.word.start-tomorrow": "Comienza mañana",
  "common.word.tomorrow": "Mañana",
  "communities.categories": "Categorías",
  "communities.categories.all": "Todas las categorías",
  "communities.for-you.edit": "Modificar mis preferencias",
  "communities.for-you.empty": "Responde a algunas preguntas para que podamos recomendarte neuvanas, retiros o comunidades permanentes según tus preferencias.",
  "communities.for-you.settings": "Definir mis preferencias",
  "communities.other-suggestions": "Otras propuestas vigentes",
  "communities.search": "Tu búsqueda",
  "communities.see-more": "Ver más comunidades",
  "community.activity.inactive": "Inactivo",
  "community.all": "Todas las comunidades",
  "community.already-exists": "Ya existe una comunidad con el mismo nombre",
  "community.close-for-today": "Cerrar por hoy",
  "community.communities.none-finished": "Aún no has completado ninguna novena, retiro ni comunidad",
  "community.communities.none-joined": "Aún no te has unido a ninguna novena, retiro o comunidad",
  "community.communities.suggested": "Sugerido para ti",
  "community.communities.team-favorite": "❤️Flechazo del equipo",
  "community.communities.view-all": "Ver todas las comunidades",
  "community.creation.suggestion": "Usted puede crear y proporcionar un curso de la oración : la novena, comunidades de retiro o permanente.",
  "community.date.from-to": "del {fromDate} al {toDate}",
  "community.description.prayer.success": "¡Gracias por su oración!",
  "community.description.read-more": "Leer más",
  "community.everlasting.unavailable-program": "Esta comunidad aún no ha publicado ninguna oración.",
  "community.join-mails.activation": "Activar los correos",
  "community.join-mails.subtitle": "Esto también te servirá como recordatorio 😉",
  "community.join-mails.title": "¿Quieres rezar {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidad}} desde tu correo electrónico?",
  "community.join-next.everlasting.start": "Hoy se ha publicado una oración en la comunidad. ¿Te gustaría rezarla?",
  "community.join-next.no-publication.start": "Mientras esperas {lifetime, select, novena {el comienzo de la novena} retreat {el comienzo del retiro} other {una primera oración}}, puedes…",
  "community.join-next.pray-now": "Rezar ahora",
  "community.join-next.start": "¿Te gustaría comenzar {lifetime, select, novena {la novena} other {el retiro}} ahora mismo?",
  "community.join-next.start-later": "Empezar más tarde",
  "community.join.already-joined": "Ya estás matriculado en esta fecha para este curso",
  "community.join.card.button": "Unirse {lifetime, select, retreat {al retiro} novena {a la novena} other {a esta comunidad}} en curso",
  "community.join.confirmation.in-progress": "Se ha unido a {lifetime, select, novena {la novena} other {el retiro}} <strong>en curso</strong>.",
  "community.join.confirmation.soon": "Vas a comenzar {lifetime, select, retreat {el retiro} novena {la novena} other {la comunidad}} el {date} {rescheduled, select, true {.} other {, <strong>en {nbDays} {nbDays, plural, one {día} other {días}}</strong>.}}",
  "community.join.confirmation.today": "Comienza {lifetime, select, retreat {el retiro} novena {la novena} other {la comunidad}} <strong>hoy.</strong>",
  "community.join.congrats": "¡Bravo {userName}! Estás inscrito(a) en la comunidad",
  "community.join.congrats.comingSoon": "¡Bravo {userName}! Comenzarás {lifetime, select, novena {la novena} other {el retiro}} el {date}",
  "community.join.congrats.ongoing": "¡Bravo {userName}! Te unes {lifetime, select, novena {a la novena} other {al retiro}} a partir de hoy",
  "community.join.congrats.startToday": "¡Bravo {userName}! Comienzas {lifetime, select, novena {la novena} other {el retiro}} hoy",
  "community.join.date": "Comienza {lifetime, select, retreat {el retiro} novena {la novena} other {la comunidad}} en la fecha que te convenga",
  "community.join.date.validate": "Confirmo esta fecha",
  "community.join.error.no-subscription": "¡Ups! Parece que hay un problema con la fecha de suscripción.",
  "community.join.from-date": "(desde el día {diffDays})",
  "community.join.infos": "Únete a los {nbMembers} usuarios que están rezando {lifetime, select, retreat {el retiro} novena {la novena} other {esta comunidad}} en este momento",
  "community.join.invalid-schedule-date": "La fecha elegida no es válida",
  "community.join.not-schedulable": "No puedes elegir una fecha para esta comunidad",
  "community.join.options.title": "¿Cuándo deseas participar en {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidad}}?",
  "community.join.scheduled-end-date.novena": "La novena terminará el {date}",
  "community.join.scheduled-end-date.retreat": "El retiro finalizará el {fecha}",
  "community.join.success.message": "Se ha unido a {lifetime, select, retreat {el retiro} novena {la novena} other {la comunidad}}.",
  "community.leave-community": "Abandonar la comunidad",
  "community.leave-everlasting-community": "Dejar de participar",
  "community.leave.already.left": "Ya has abandonado esta comunidad",
  "community.leave.confirm": "¿Realmente quieres {lifetime, select, novena {detener esta novena?} retreat {salir de este retiro?} other {salir de esta comunidad?}}",
  "community.leave.fail": "Se ha producido un error, intenta de nuevo",
  "community.leave.success": "Ha abandonado {lifetime, select, novena {la novena} retreat {el retiro} other {la comunidad}}",
  "community.load.error": "Se ha producido un error al cargar la comunidad",
  "community.not-found": "Esta comunidad no existe",
  "community.not-joined": "No eres o ya no eres miembro de esta comunidad.",
  "community.notifications.activate-push": "Activar las notificaciones",
  "community.notifications.receive-publications-push": "¿Deseas recibir una notificación por cada publicación de {lifetime, select, novena {esta novena} retreat {este retiro} other {esta comunidad}}?",
  "community.notifications.receive-publications-push.subtitle": "Te enviaremos una notificación {lifetime, select, novena {cada día de esta novena} retreat {cada día de este retiro} other {por cada oración de esta comunidad}}",
  "community.private.private": "Privada",
  "community.publication.error.publication.not-accessible": "A publicação não é acessível para o momento.",
  "community.role.administrator.long": "Eres un administrador",
  "community.role.animator.long": "Eres un animador",
  "community.role.creator.long": "Tu eres el creador",
  "community.share.text": "Tal vez alguien de tu entorno esté interesado. Pide al Espíritu Santo que te guíe 😇",
  "community.status.check.validating": "Está siendo validado",
  "community.status.draft.word": "Borrador",
  "community.tab.description": "Descripción",
  "community.toolbar.community": "Ver la comunidad",
  "community.toolbar.stop": "Salir {lifetime, select, retreat {del retiro} novena {de la novena} other {de la comunidad}}",
  "community.toolbar.title": "Espacio animador",
  "community.unavailable-program": "El programa para {lifetime, select, retreat {este retiro} other {esta novena}} aún no está disponible.",
  "community.unmodifiable": "No puedes modificar esta comunidad",
  "community.virtus.publications.empty": "Tu contenido se mostrará aquí",
  "communityAnnouncement.community.user.not-allowed": "No está permitido publicar un anuncio para los miembros de esta comunidad",
  "communityAnnouncement.message.too-long": "¡Oh! El contenido de su anuncio es demasiado largo",
  "communityAnnouncement.subject.too-long": "¡Oh! El tema de su anuncio es demasiado largo",
  "contact.captcha_v2.title": "Por favor, confirma que eres un humano",
  "contact.email.invalid": "Por favor, introduce una dirección de correo electrónico válida",
  "contact.firstname.invalid": "Por favor, introduce tu nombre",
  "contact.firstname.placeholder": "Nombre",
  "contact.firstname.tooLong": "El nombre no puede exceder los 30 caracteres",
  "contact.lastname.invalid": "Por favor, introduce tu nombre",
  "contact.lastname.label": "Tu nombre",
  "contact.lastname.placeholder": "Apellido",
  "contact.load.error": "Se ha producido un error al buscar a su destinatario.",
  "contact.message.alert": "Si reportas un problema encontrado en el sitio o en la aplicación, por favor descríbelo lo más detalladamente posible en el campo de abajo:",
  "contact.message.invalid": "Por favor, introduce un mensaje",
  "contact.message.label": "Contenido de tu mensaje",
  "contact.message.tooShort": "El mensaje debe contener al menos 100 caracteres",
  "contact.send-message": "Enviar un mensaje",
  "contact.subject.invalid": "Por favor, introduce el asunto de tu mensaje",
  "contact.subject.label": "Asunto de tu mensaje",
  "contact.subject.placeholder": "Asunto",
  "contact.subtitle": "Estaremos encantados de responderte 😊",
  "contact.success.toast": "Tu mensaje se ha enviado correctamente. ¡Te responderemos lo antes posible!",
  "content.forbidden-content": "Este contenido no es válido",
  "content.invalid": "El contenido no es válido o está vacío",
  "content.invalid-contain-email": "Tu intención no debe contener un correo electrónico",
  "content.invalid-contain-url": "Tu intención no debe contener un enlace",
  "content.required": "Necesitas escribir un comentario antes de publicarlo",
  "content.too-long": "Este contenido es demasiado largo. Utilice solo letras o números",
  "content.too-short": "Este contenido es demasiado corto. Utilice solo letras o números",
  "conversation.ambiguous-definition": "Vaya, ha surgido un pequeño problema. Si el problema persiste, contáctanos",
  "conversation.block": "Bloquear la conversación",
  "conversation.few-seconds": "Hace un momento",
  "conversation.mark-as-unread": "Marcar como no leído",
  "conversation.not-found": "Esta conversación no existe",
  "conversation.unblock": "Desbloquear conversación",
  "conversation.user.not-allowed": "¡Ay! No tienes acceso a esta conversación. ¿Estás seguro de estar conectado con la cuenta correcta?",
  "conversation.you-blocked": "Bloqueaste la conversación",
  "conversations.unread": "Sin leer",
  "cta.share": "Compartir",
  "dates.invalid": "Las fechas no son correctas",
  "day.count": "Día {number}",
  "description.forbidden-content": "La descripción no es válida",
  "description.invalid": "Falta la descripción",
  "description.required": "Falta la descripción",
  "description.too-long": "La descripción es demasiado larga",
  "description.too-short": "La descripción es demasiado corta",
  "device.delete.not.found": "No se encontró el dispositivo que desea eliminar",
  "discover.see-more": "Ver más contenido",
  "draft.conflict": "Esta publicación no puede ser registrada como borrador.",
  "email.already-exists": "Este correo electrónico ya existe",
  "email.invalid": "La dirección de correo electrónico no es válida",
  "email.user.not-found": "No se encontró ningún usuario con esta dirección de correo electrónico",
  "error.403.title": "No tiene acceso a esta página",
  "error.404.message": "Encuentra comunidades que puedan ayudarte a orar",
  "error.404.quote": "¡Busquen al Señor mientras se deja encontrar, \nllámenlo mientras está cerca!\n Isaías 55.6",
  "error.404.title": "Lo siento, esta página no existe en Hozana …",
  "favorite.not-found": "Publicación favorita no encontrada",
  "file.not-an-image": "El archivo subido no es una imagen. Solo se aceptan archivos JPG / PNG / GIF",
  "fraternity.gender.question": "Usted es:",
  "fraternity.gender.title": "Para proponerle fraternidades no mixtas",
  "fraternity.join.already-have": "Ya tengo una fraternidad",
  "fraternity.join.already-have-description": "Ya sabe con quién vivirá Virtus",
  "fraternity.join.find": "Encuéntrenme una fraternidad",
  "fraternity.join.find-description": "Le pondremos en contacto con otros participantes",
  "fraternity.join.subtitle": "Las fraternidades Virtus están formadas solo por mujeres o solo por hombres.",
  "fraternity.join.title": "¿Tiene personas cercanas con quienes formar una fraternidad?",
  "fraternity.lead.accept": "De acuerdo",
  "fraternity.lead.decline": "Prefiero no",
  "fraternity.lead.description": "Este rol consiste simplemente en organizar y animar las reuniones de fraternidad. No tendrá que llevarlo todo ni ser un experto espiritual.",
  "fraternity.lead.learn-more": "Saber más sobre este rol",
  "fraternity.lead.title": "¿Acepta ser jefe de fraternidad?",
  "fraternity.onboarding.close.body": "Si sale ahora se inscribirá en Virtus sin estar vinculado a una fraternidad.",
  "fraternity.onboarding.close.footer": "Podrá solicitar estar vinculado a una fraternidad en cualquier momento.",
  "fraternity.onboarding.close.title": "¿Realmente quiere vivir Virtus sin fraternidad?",
  "fraternity.place.city-label": "¿En qué ciudad vive?",
  "fraternity.place.hint": "Elija encuentros cerca de usted o totalmente a distancia.",
  "fraternity.place.nearby": "Cerca de usted",
  "fraternity.place.nearby-description": "Buscar participantes en su zona",
  "fraternity.place.remote": "A distancia",
  "fraternity.place.remote-description": "Encuentre a su fraternidad allá donde esté",
  "fraternity.place.title": "¿Dónde desea encontrar a su fraternidad?",
  "fraternity.presentation.item.encourage": "Anímense mutuamente durante el recorrido",
  "fraternity.presentation.item.pray": "Recen unos por otros",
  "fraternity.presentation.item.share": "Compartan cada semana lo que viven",
  "fraternity.presentation.subtitle": "Virtus se vive en una fraternidad no mixta de 8 personas.",
  "fraternity.presentation.title": "Viva la Cuaresma en fraternidad",
  "fraternity.ready.eager-no": "Todavía dudo un poco 😅",
  "fraternity.ready.eager-yes": "¡Sí, estoy listo(a) para vivir esta Cuaresma plenamente! 💪🏻",
  "fraternity.ready.subtitle": "El recorrido Virtus es exigente. ¿Está listo(a) para comprometerse seriamente en esta Cuaresma?",
  "fraternity.ready.title": "¡Bienvenido(a) al recorrido Virtus!",
  "fraternity.recap.cta": "Buscar una fraternidad",
  "fraternity.recap.lead": "Jefe de fraternidad",
  "fraternity.recap.place": "Lugar de fraternidad deseado",
  "fraternity.recap.sex": "Sexo",
  "fraternity.recap.subtitle": "Corríjalos si es necesario antes de lanzar la búsqueda.",
  "fraternity.recap.title": "Verifique su información",
  "fraternity.step-label": "Su fraternidad · {step} / 4",
  "fromDate.in-the-futur": "¡Lo siento! Necesitas seleccionar una fecha futura como fecha de inicio",
  "fromDate.in-the-past": "¡Maldita sea! No puedes elegir una fecha pasada como fecha de inicio",
  "getCommunitiesJoined.user.not-found": "No podemos encontrar comunidades",
  "getCommunitiesWithRole.user.not-found": "No podemos encontrar comunidades",
  "getCommunityNotifications.subscriptionId.not-found": "No pudimos cargar sus preferencias de notificación para esta comunidad",
  "guestName.required": "Falta el nombre",
  "guestName.too-long": "El nombre es demasiado largo",
  "guide.not-found": "No se encontraron artículos en esta guía",
  "hash.invalid": "Ocurrió un error: 'hash inválido'",
  "hash.required": "Ocurrió un error: 'hash requerido'",
  "home.faq.title.head": "¿Cómo funciona?",
  "home.tagline": "Nuestra oración salvará al mundo",
  "home.tagline.sub": "¡Y cambiará tu vida!",
  "home.welcome.app-section.title": "Descarga la aplicación",
  "home.welcome.intentions.title": "Deja tus intenciones\ny ora por otras personas",
  "iframe.error.description": "No se pudo cargar el contenido. Comprueba tu conexión a internet e inténtalo de nuevo.",
  "iframe.error.title": "No se pudo conectar",
  "intention.anonymous-praying": "Anónimo",
  "intention.answer.uplift": "Responder a este mensaje de apoyo",
  "intention.arrival.just-joined": "{userName} acaba de unirse a Hozana",
  "intention.arrival.welcome-pray": "¡Dale la bienvenida con una oración!",
  "intention.birthday.celebration": "¡{username} celebra su {years} cumpleaños!",
  "intention.birthday.pray": "¡Deséale feliz cumpleaños en oración!",
  "intention.birthday.years-old": "{age, plural, one {{age} año} other {{age} años}}",
  "intention.created.description": "Se propondrá a los miembros de la comunidad durante 48 horas.",
  "intention.created.success": "Su intención ha sido depositada",
  "intention.delete.confirm-message1": "¿Realmente quieres eliminar la intención que tienes publicada?",
  "intention.delete.confirm-message2": "Los orantes ya no podrán orar por tu intención, y tú no podrás dar las gracias a todos los que oraron por ella.",
  "intention.delete.delete": "Eliminar mi intención",
  "intention.finished.arrival": "{count, plural, =0 {Nadie} one {{count} persona} other {{count} personas}} ha rezado para darte la bienvenida en Hozana!",
  "intention.finished.birthday": "{birthdayDate}, {count, plural, =0 {nadie} one {{count} persona} other {{count} personas}} ha rezado para desearte un feliz cumpleaños!",
  "intention.finished.intention": "El tiempo para mostrar tu intención ha expirado. {count, plural, =0 {Nadie oró por ti} one {{count} nadie oró por ti} other {{count} personas oraron por ti}}. <link>Ver intención</link>",
  "intention.finished.prayers": "{count, plural, =0 {Nadie oró} one {{count} persona oró} other {{count} personas oraron}} {type, select, arrival {para darte la bienvenida a Hozana} birthday {para ti en la ocasión de tu cumpleaños} other {por tu intención} }{count, plural, =0 {.} one {, ¿te gustaría agradecerle?} other {, ¿te gustaría agradecerles?}}",
  "intention.finished.thank": "Doy gracias a los orantes",
  "intention.from": "Intención de {contactName}",
  "intention.invitation-to-pray-for": "{name} te invita a rezar por su intención",
  "intention.load.error": "Se ha producido un error. No se pudo cargar la intención.",
  "intention.not-found": "No se encontró la intención",
  "intention.page.button": "Dejar una intención",
  "intention.pray-for": "Orar por intenciones",
  "intention.prayed.already": "Acabas de orar por esta intención.",
  "intention.prayed.already-with": "Tú{count, plural, =0 {} one { y otra persona} other { y # otras personas} } han orado por esta intención. ¡Gracias!",
  "intention.prayed.birthday": "Tú{count, plural, =0 {} one { y otra persona} other { y # personas}} oraron por {userName}",
  "intention.prayed.by": "{count, plural, =0 {nadie ha orado aún} =1 {{name} ha orado} =2 {{otherNames} y {name} han orado} =3 {{otherNames} y {name} han orado} =4 {{otherNames}, {name} y otra persona han orado} other {{otherNames}, {name} y {remainingCount} otras personas han orado}} por esta intención",
  "intention.prayed.pray-for-others": "👉🏻 ¿Te gustaría orar por otras intenciones?",
  "intention.prayed.thanks": "¡Gracias!",
  "intention.prayed.with": "🙏 {count} {count, plural, one {persona ha rezado} other {personas han rezado}} contigo por esta intención",
  "intention.prayer.not-found": "Este usuario no parece haber rezado por ti",
  "intention.prayer.watchman.activate-notifications": "Para recibir la notificación, necesitas activarla.",
  "intention.prayer.watchman.became-watchman": "Eres un Guardián de Oración!",
  "intention.prayer.watchman.become": "Ser centinela de oración",
  "intention.prayer.watchman.commitment": "Te has comprometido a recibir 3 intenciones diarias para rezar por ellas",
  "intention.prayer.watchman.engagement.1": "Convirtiéndote en <strong>Guardián de Oración</strong> :",
  "intention.prayer.watchman.engagement.2": "3 intenciones todos los días",
  "intention.prayer.watchman.engagement.3": "Para que reces por ellas",
  "intention.prayer.watchman.fetching": "Estamos recuperando las 3 intenciones que te confiamos hoy",
  "intention.prayer.watchman.join": "Acepto ser guardián de oración",
  "intention.prayer.watchman.many-watchmen": "🙏 ¡Ya <strong>103 456</strong> personas se han comprometido!",
  "intention.prayer.watchman.method-reminder": "¿Cómo deseas recibir tu recordatorio diario de oración?",
  "intention.prayer.watchman.pray-support": "Sostén a tus hermanos y hermanas con tus oraciones",
  "intention.prayer.watchman.reminder.by-email": "Por correo electrónico",
  "intention.prayer.watchman.reminder.by-notification": "Por notificación",
  "intention.prayer.watchman.resign": "Quiero parar",
  "intention.prayer.watchman.stop": "Dejar de participar",
  "intention.prayers.list.title": "Ellos oraron por tí",
  "intention.publish.button": "Dejo mi intención aquí",
  "intention.reload": "Ver otras intenciones",
  "intention.share": "Comparte esta intención",
  "intention.time-left": "{count}h",
  "intention.title": "Deja tus intenciones y ora por las de los demás",
  "intention.watchman.arrival.just-joined": "Estás rezando por {userName}, que acaba de llegar a Hozana",
  "intention.write.here": "Escribe tu intención de oración aquí",
  "intentions.not-found": "No encontramos una intención de mostrar",
  "intentions.title": "¡Deja una intención en Hozana!",
  "intentions.view": "Ver las intenciones",
  "introduction.forbidden-content": "El texto de introducción no es válido",
  "introduction.too-long": "El texto de introducción es demasiado largo",
  "introduction.too-short": "El texto de introducción es demasiado corto",
  "joinCommunity.community.join.already-finished-community": "Esta comunidad ha terminado",
  "journey.discover.current": "Ver los caminos del momento",
  "journey.empty.active": "No tienes ningún recorrido en curso.",
  "journey.none.now": "Ningún camino por el momento",
  "journey.novenas-and-journeys": "Novenas y retiros",
  "journey.once.subscribed": "Cuando te inscribas en una novena o un camino, lo encontrarás aquí",
  "journey.prayed.today": "Oración de hoy completada",
  "journey.see-history": "Historial",
  "lang.unsupported": "El idioma que solicita no es compatible actualmente",
  "language.en": "Inglés",
  "language.es": "Español",
  "language.fr": "Francés",
  "language.it": "Italiano",
  "language.pl": "Polaco",
  "language.pt": "Portugués",
  "leave.confirm.message": "Tu cuenta ha sido eliminada correctamente",
  "leave.guides-title": "Descubre nuestras guías temáticas",
  "leave.pray-differently": "¿Te gustaría rezar de una manera diferente?",
  "leave.sign-up-again": "👋🏻 Estaremos encantados de darte la bienvenida de nuevo si deseas seguir rezando con nosotros",
  "login.account.disabled": "Tu cuenta ha sido desactivada",
  "login.account.missing": "No se encontró ninguna cuenta que coincida con esta dirección de correo electrónico",
  "login.code-input.check-email": "Por favor, verifica el código que recibiste por correo electrónico.",
  "login.code.required": "Código obligatorio",
  "login.csrf.invalid": "Tu sesión ha caducado, inténtalo de nuevo",
  "login.email.invalid": "Dirección de email no válida",
  "login.email.not-provided": "Por favor, indique o seu endereço de e-mail",
  "login.email.required": "Correo electrónico requerido",
  "login.failed": "El código no es válido o ha caducado",
  "login.password.required": "Contraseña requerida",
  "meeting.organizer.place.name-placeholder": "Iglesia San Pedro",
  "meeting.organizer.time-invalid": "Por favor indica la hora de la reunión en formato HH:MM",
  "meeting.organizer.timeStart-invalid": "La hora de inicio debe ser inferior a la hora de finalización",
  "message.automatic-message": "Mensaje automático",
  "message.delete": "Suprimir el mensaje",
  "message.delete.user.not_allowed": "¡Oh! No puedes borrar este mensaje",
  "message.deleted": "Mensaje eliminado",
  "message.from": "Mensaje de {contactName}",
  "message.godfather.welcome-message.to-godfather": "{contactName} acaba de unirse a Hozana gracias a tu invitación. ¡Dale la bienvenida!",
  "message.godfather.welcome-message.to-godson": "Te uniste a Hozana por invitación de {contactName}. ¡Bienvenido!",
  "message.godfather.welcome-title.to-godfather": "Aquí estoy",
  "message.godfather.welcome-title.to-godson": "¡Te damos la bienvenida a Hozana!",
  "message.invalid": "Mensaje inválido",
  "message.list.title": "Mensajería",
  "message.list.title.conversation": "Para iniciar una conversación con un usuario de Hozana, comience orando en la página de Intenciones.",
  "message.list.title.cta": "Rezo por una intención",
  "message.list.title.intention": "La persona por la que oraste podrá agradecerte e iniciar una conversación contigo.",
  "message.prayer-on-arrival.has-thanked-you": "{contactName} te agradece por haber orado cuando se unió a Hozana.",
  "message.prayer-on-arrival.you-thanked-for": "Has agradecido a {contactName} por haber rezado por tu llegada a Hozana.",
  "message.prayer-on-birthday.has-thanked-you": "{contactName} te agradece por orar por él en su cumpleaños.",
  "message.prayer-on-birthday.you-thanked-for": "Agradeciste a {contactName} por orar por ti en tu cumpleaños.",
  "message.prayer-on-comment.has-prayed-for-you": "{contactName} oró por tí desde un comentario",
  "message.prayer-on-comment.you-prayed-for": "Oraste por {contactName} desde un comentario",
  "message.prayer-on-intention.thank-you": "Has agradecido a {contactName} por rezar por tu intención",
  "message.prayer-on-intention.thanked-you": "{contactName} te agradece por haber rezado por su intención",
  "message.prayer.has-just-prayed-for-you.short-multiple": "{count} personas han rezado por ti!",
  "message.prayer.has-just-prayed-for-you.short-single": "{contactName, select, _ {Alguien} other {{contactName}}} acaba de rezar por ti!",
  "message.prayer.has-prayed-for-you.long": "{contactName} oró por ti",
  "message.prayer.you-prayed-for.long": "Rezaste por {contactName}",
  "message.reported": "Este mensaje ha sido reportado y la conversación bloqueada, ¡gracias por tu ayuda!",
  "message.suspicious.received": "La persona con la que estás hablando te ha enviado un enlace para hacer clic, un número para llamar o te ha propuesto un lugar de encuentro. Por favor, asegúrate de confiar en esta persona antes de continuar con la conversación.",
  "message.suspicious.sent": "Parece que has compartido tu número de teléfono, tu dirección de correo electrónico o un enlace. Asegurarte de que confías en la persona antes de continuar la interacción en otra plataforma menos segura.",
  "message.textarea.help.return": "Shift + Enter teclas para volver a la línea",
  "message.unselected": "No hay conversación seleccionada",
  "message.update.user.not_allowed": "¡Oh! No puedes editar este mensaje",
  "missing.parameters": "¡Ups! Faltan algunos parámetros para enviar un mensaje de apoyo.",
  "name.exists": "Este nombre ya ha sido dado a otra publicación",
  "name.forbidden-content": "Este nombre no es válido",
  "name.invalid": "Nombre no válido",
  "name.required": "Por favor, introduce tu nombre",
  "name.too-long": "Este nombre es demasiado largo. Utilice solo letras o números",
  "name.too-short": "Este nombre es demasiado corto. Utilice solo letras o números",
  "native.push.how-to.reactivate.description": "Al hacer clic en \"Sí, activar las notificaciones\", te guiaremos a los ajustes de tu iPhone. Solo tienes que activar la opción \"Notificaciones\" y pulsar la flecha de retroceso ⬅️ de la parte superior para volver.",
  "navigation.confession-link": "Confesarse",
  "navigation.guides.title": "Nuestros guías",
  "navigation.intentions": "Presentar una intención",
  "navigation.live-page-link": "Misas y oración en vivo",
  "navigation.search": "Buscar en Hozana",
  "notificationEmail.invalid": "El correo electrónico de las notificaciones es inválido.",
  "oldPassword.invalid": "La contraseña actual, no corresponde a la que ha sido indicada.",
  "page.gone": "Esta página ya no existe",
  "page.not-found": "Página no encontrada",
  "password.required": "Se requiere contraseña",
  "password.too-long": "La contraseña es demasiado larga",
  "payload.bad-content": "El contenido no es válido",
  "payload.text-too-long": "Tu mensaje es muy largo",
  "pictureFileId.required": "Falta la imagen",
  "postIntention.content.too-long": "El contenido de la intención es demasiado largo",
  "pray.amen": "¡Amén!",
  "pray.comment.title": "Estás orando por {userName}",
  "pray.entrust-intention": "Confía una intención {buttonText}",
  "pray.entrust-intention.body": "Otros orantes de Hozana rezarán por tu intención.",
  "pray.i-pray.short": "Oro",
  "pray.intention.arrival.title": "Usted reza por {userName} que acaba de llegar a Hozana",
  "pray.intention.birthday.title": "¡Es el cumpleaños de {userName}!",
  "pray.intention.community.show": "Reza por la intención de {user}, quien también está {lifetime, select, retreat {registrado(a) en este retiro} novena {registrado(a) en esta novena} other {miembro de esta comunidad}}",
  "pray.intention.publication.done": "{user} ha dejado esta intención",
  "pray.intention.publication.show": "{user} también está orando en “{community}”, ¿te gustaría orar por su intención?",
  "pray.intention.show": "¿Y ahora, quieres orar por la intención de {user}?",
  "pray.intention.title": "Estás orando por la intención de {userName}",
  "pray.pray": "Orar",
  "pray.pray-today": "Orar hoy",
  "pray.prayed": "Termino mi oración",
  "pray.prayer-sent": "Tu intención de oración ha sido enviada",
  "pray.uplift.description": "Solo {userName} verá este mensaje",
  "pray.uplift.sent": "Tu mensaje de ánimo se ha enviado correctamente",
  "pray.uplift.title": "¿Deseas dejar un mensaje de ánimo para {userName}?",
  "pray.write-intention": "¿También quieres dejar una intención de oración?",
  "pray.your-intention": "Tu intención de oración",
  "prayer-space.discover": "Esto podría interesarte",
  "prayer-space.everlasting.load.error": "Se produjo un error al cargar la sección \"A diario\"",
  "prayer-space.journey.load.error": "Se produjo un error al cargar la sección \"Novenas y retiros\"",
  "prayer-space.onboarding.step-1.description": "Todo el equipo de Hozana se alegra de presentarte este nuevo Espacio de Oración, que te ayudará a crecer en la fidelidad a tu oración diaria.",
  "prayer-space.onboarding.step-1.title": "¡Nuevo Espacio de Oración!",
  "prayer-space.onboarding.step-2.description": "¡Encuentra fácilmente las novenas y retiros que sigues actualmente y consulta tu progreso!",
  "prayer-space.onboarding.step-2.title": "Sigue tus Novenas y Retiros",
  "prayer-space.onboarding.step-3.description": "Encuentra tus oraciones diarias en la sección «A diario»: el Evangelio del día, la Liturgia de las Horas, oraciones con el santo del día y mucho más.",
  "prayer-space.onboarding.step-3.title": "Encuentra tus oraciones diarias",
  "prayer-space.onboarding.step-4.description": "En la sección «Esto podría interesarte», descubre las propuestas del momento y vuelve a disfrutar de las novenas y retiros con los que te gustó rezar.",
  "prayer-space.onboarding.step-4.title": "Descubre la riqueza de la oración en Hozana",
  "prayer-space.welcome.discover": "Todas nuestras propuestas",
  "prayer-space.welcome.end-paragraph": "Si estas sugerencias no son lo que buscas, echa un vistazo a todos nuestros contenidos. Seguro que allí encontrarás una novena, retiro o comunidad permanente adaptada a tus necesidades espirituales.",
  "prayer-space.welcome.paragraph": "<strong>Te damos la bienvenida {userName},</strong>\nEste es tu <strong>lugar de oración</strong> 🙏🏻 !\nY aquí encontrarás las oraciones y meditaciones que compartiremos contigo.\n👉🏻 <strong>Desde ya puedes inscribirte a nuestras diferentes propuestas</strong> para recibir el contenido que hemos preparado para ti.",
  "prayer.start": "Comenzar a rezar",
  "prayerContent.invalid": "El contenido de la oración no es válido o está vacío",
  "prayerContent.too-long": "El contenido de la oración de su comunidad es demasiado largo",
  "prayerName.invalid": "El título de la oración no es válido o está vacío",
  "prayerName.required": "Por favor nombre su oración comunitaria",
  "prayerName.too-long": "El nombre de la oración comunitaria es demasiado largo",
  "prayerSample.not-found": "¡Vaya! No puedes elegir esta oración",
  "publication.already-exists": "Ya existe una publicación con el mismo nombre en tu comunidad",
  "publication.comment.loadmore": "Cargar más comentarios",
  "publication.comment.loadmoreanswers": "Cargar más respuestas",
  "publication.comment.show": "Mostrar los comentarios",
  "publication.comment.title": "{count} {count, plural, one {Comentario} other {Comentarios}}",
  "publication.day": "Día {day}",
  "publication.favorite.add": "Añadir a favoritos",
  "publication.favorite.how-to": "Puedes guardar una publicación haciendo clic en el botón de opciones de la publicación",
  "publication.favorite.none.now": "No hay publicaciones favoritas",
  "publication.favorite.remove": "No volver a guardar",
  "publication.favorite.removed": "La publicación ha sido eliminada de tus favoritos",
  "publication.favorite.success": "La publicación se ha agregado a tus favoritos",
  "publication.frequency.type.daily": "Cada día",
  "publication.frequency.type.long.daily": "Una oración diaria",
  "publication.frequency.type.long.monthly": "Una oración {value, plural, one {una vez} other {# veces}} por mes",
  "publication.frequency.type.long.sporadically": "Una oración de vez en cuando",
  "publication.frequency.type.long.weekly": "Una oración cada {value}",
  "publication.frequency.type.monthly": "{value, plural, one {Una vez} other {# veces}} por mes",
  "publication.frequency.type.sporadically": "De vez en cuando",
  "publication.frequency.type.weekly": "Cada {value}",
  "publication.goto": "Ver la comunidad",
  "publication.load.error": "Se ha producido un error. No se ha podido cargar la publicación.",
  "publication.not-found": "Esta publicación no fue encontrada",
  "publication.prayed": "🙏 {count} {count, plural, one {persona ha orado} other {personas han orado}} contigo",
  "publication.prayed-by": "{count, plural, =0 {Has orado por esta publicación} =1 {Tú y otra persona han orado por esta publicación} other {Tú y {count} personas han orado por esta publicación}}",
  "publication.prayed-by.short": "{count, plural, =0 {Rezaste} =1 {Tú y otra persona oraste} other {Tú y {count} otras personas oráron}}",
  "publication.prayed.share.body": "¡Compártele la publicación o la comunidad!😇",
  "publication.prayed.share.button": "Lo comparto con un amigo",
  "publication.prayed.share.choose.body": "¡Al compartir este contenido de oración quizá ayudes a <strong> transformar profundamente la vida de alguien! 😇 </strong>",
  "publication.prayed.share.choose.title": "¿Qué deseas compartir?",
  "publication.prayed.share.community.button": "Compartir la comunidad",
  "publication.prayed.share.community.modal.title": "Compartir esta comunidad",
  "publication.prayed.share.publication.button": "Compartir la publicación",
  "publication.prayed.share.publication.modal.title": "Compartir esta publicación",
  "publication.prayed.share.title": "¿Conoces a alguien a quién le podría gustar esta oración que acabas de leer?",
  "publication.update": "Editar la publicación",
  "publicationFrequencyType.required": "Por favor indique la frecuencia de la publicación",
  "publicationFrequencyValue.invalid": "La frecuencia de publicación elegida no es válida",
  "publicationFrequencyValue.required": "Ingrese una frecuencia de publicación",
  "push.activated": "Las notificaciones han sido activadas correctamente",
  "push.allow.message": "Acepta ahora la solicitud que te hace tu navegador para activar las notificaciones.",
  "push.blocked.how-to.reactivate": "¿Cómo reactivar las notificaciones?",
  "push.blocked.how-to.settings.allow": "autoriza <i>hozana.org</i>, a enviarte las notificaciones.",
  "push.blocked.how-to.settings.find-hozana": "en la lista de páginas, encuentra <i>hozana.org</i>,",
  "push.blocked.how-to.settings.find-list": "encuentra ya sea las autorizaciones dadas a las páginas, o ya sea en los parámetros de las notificaciones,",
  "push.blocked.how-to.settings.icon": "Si no ves este ícono, será necesario ir a los parámetros del navegador:",
  "push.blocked.how-to.url-icon.allow": "sólo te queda retirar la prohibición de envío de las notificaciones.",
  "push.blocked.how-to.url-icon.browser": "En muchos navegadores, encontrás un ícono en forma de cadenas en la barra de dirección de la página: a la izquierda o a la derecha de <i>hozana.org/es/comunidad/…</i>",
  "push.blocked.how-to.url-icon.click": "haz clic en este ícono, y encuentra la opción \"notificaciones\",",
  "push.blocked.message": "Has bloqueado las notificaciones en este dispositivo. Actívalas si deseas recibir nuevamente las notificaciones de la parte de Hozana.",
  "push.blocked.support-link": "Visitar la ayuda dedicada de {browser} para tener más detalles en caso de problemas",
  "push.blocked.title": "Notificaciones bloqueadas",
  "reportAbuse.reason.required": "Debe especificar el motivo de su denuncia",
  "reportAbuse.type.invalid": "¡Vaya! Error técnico: su informe no se envió",
  "resetPassword.token.invalid": "Se ha producido un error: inténtelo de nuevo haciendo clic de nuevo en \" ¿Olvidó su contraseña? \"",
  "role.invalid": "No se puede aceptar este rol",
  "rosario.bloc.cta": "Rezo el rosario en Rosario",
  "rosario.bloc.description.1": "1 – Forma un grupo de oración de 5 personas",
  "rosario.bloc.description.2": "2 – Cada día, cada uno recibe un misterio del rosario y dedica 5 minutos de su día a meditarlo rezando una decena",
  "rosario.bloc.description.3": "3 – Al final del día, el grupo habrá meditado los 5 misterios del día, completando así un rosario entero: ¡es el rosario viviente!",
  "rosario.bloc.title": "¡Descubre la primera aplicación de rosario viviente!",
  "rosario.xmrpms.cta": "Participar en el regalo",
  "rosario.xmrpms.description": "En mayo, mes de María, <strong>cada decena</strong> rezada en Rosario es <strong>una rosa</strong> que se le ofrece!",
  "rosario.xmrpms.objective": "Objetivo: <strong>5 millones de rosas antes del 31 de mayo.</strong>",
  "rosario.xmrpms.title": "Únete a un GRAN regalo a María",
  "scheduledTime.invalid": "La fecha del programa de publicación no es válida",
  "score-threshold-not-met": "No se ha alcanzado la puntuación de verificación. Por favor, completa la verificación.",
  "sendMessage.payload.bad-content": "¡Hmm! No puedes enviar el contenido de este mensaje",
  "settings.account.birthdate": "Fecha de nacimiento",
  "settings.account.confirm-password": "Confirme su nueva contraseña",
  "settings.account.current-password": "Tu contraseña anterior",
  "settings.account.delete": "Eliminar la cuenta",
  "settings.account.delete.confirm": "Estás a punto de eliminar tu cuenta de Hozana. ¡Cuidado! Esta acción es irreversible.\n\nPara confirmar la eliminación definitiva de tu cuenta, escribe la palabra <strong>ELIMINAR</strong> (en mayúsculas) en el campo a continuación y confirma.",
  "settings.account.delete.error-input": "Debes escribir ELIMINAR aquí",
  "settings.account.delete.input": "Escribir ELIMINAR aquí",
  "settings.account.new-password": "Tu nueva contraseña",
  "settings.card.community.announce": "Recibir los anuncios",
  "settings.card.community.announce.details": "Para que los animadores de la comunidad puedan enviarte un mensaje",
  "settings.card.community.prayer": "Recibir cada oración",
  "settings.card.notifs.email": "Por correo electrónico",
  "settings.card.notifs.push": "Por notificación",
  "settings.email.disable.all": "Activar los correos electrónicos para todos los ajustes",
  "settings.header.notifications": "Correos y notificaciones",
  "settings.header.title.community": "Configuración de la comunidad",
  "settings.input.email-is-not-valid": "Por favor indica un correo electrónico válido",
  "settings.input.name-is-not-email": "Solo tienes que introducir un nombre",
  "settings.input.password.label": "Contraseña de tu cuenta",
  "settings.input.password.social-connect": "Está conectado por una cuenta {socialName}. Para conectarse por contraseña, defina uno.",
  "settings.input.title.placeholder": "Sr., Sra., Padre, Hermana ...",
  "settings.language.title": "Tu lenguaje de cuenta",
  "settings.notifications.community-registration.title": "Te has inscrito en una comunidad, novena o retiro",
  "settings.notifications.disable.all": "Activar las notificaciones en todos los ajustes",
  "settings.notifications.end-of-novena.title": "Tu recorrido está terminando",
  "settings.notifications.general.description": "Correos y notificaciones sobre intenciones, y otras funcionalidades",
  "settings.notifications.general.title": "Notificaciones generales",
  "settings.notifications.incriptions.description": "Correos electrónicos y notificaciones de las novenas, itinerarios y contenidos diarios",
  "settings.notifications.incriptions.title": "Notificaciones relacionadas con mis inscripciones",
  "settings.notifications.intention-end-time.title": "Fin de visualización de tu intención de oración",
  "settings.notifications.invited-join.title": "Un invitado acaba de unirse a Hozana gracias a ti",
  "settings.notifications.message.title": "Nuevo mensaje",
  "settings.notifications.newsletter.title": "Newsletter (boletín semanal) Hozana",
  "settings.notifications.no-ongoing-community.title": "Recordatorio para unirte a un recorrido",
  "settings.notifications.pray-remind.title": "Recordatorio de oración diaria",
  "settings.notifications.watchman-remind.title": "Recordatorio Centinela de oración",
  "settings.notifications.watchman.description": "Configuración y recordatorios",
  "settings.notifications.watchman.title": "Eres un Vigía de oración",
  "settings.profile-and-settings": "Perfil y configuración",
  "settings.unsubscribe-presubscriber.error": "Se produjo un error durante la cancelación de la suscripción",
  "settings.unsubscribe-presubscriber.success": "Te has dado de baja",
  "share.community": "Comparte {lifetime, select, novena {esta novena} retreat {este retiro} other {esta comunidad}}",
  "share.community.share": "Comparte {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidad}}",
  "share.copied-link": "Enlace copiado",
  "share.copy-link": "Copiar el link",
  "share.intention.email-body": "Te invito a orar por esta intención: {intentionUrl}.",
  "share.intention.share": "Compartir esta intención",
  "share.my.intention.email-body": "Te invito a orar por mi intención: {intentionUrl}.",
  "share.publication.email-body": "Te invito a descubrir esta publicación « {publicationName} » en Hozana: {publicationUrl}.",
  "share.share": "Compartir",
  "share.share-by-email": "Invito por correo electrónico",
  "share.share-by-email-body": "Te invito a descubrir {lifetime, select, retreat {este retiro} novena {esta novena} other {esta comunidad}} en Hozana « {communityName} » : {url}.",
  "share.wording.send-email": "Enviar un email",
  "share.wording.share-on-whatsapp": "Compartir en Whatsapp",
  "signup.captcha.required": "Por favor elije \"No soy un robot\"",
  "signup.code.invalid": "El código no es válido o ha caducado",
  "signup.email.exists": "Ya existe una cuenta con esta dirección de email",
  "signup.email.invalid": "Correo electrónico inválido",
  "signup.email.required": "Correo electrónico requerido",
  "signup.fail": "Ha ocurrido un error en la creación de tu cuenta",
  "signup.name.invalid": "Ha ocurrido un error debido a tu nombre",
  "signup.name.required": "Nombre requerido",
  "signup.password.required": "Contraseña requerida",
  "startConversation.payload.bad-content": "¡Mmm! No puedes enviar el contenido de este mensaje",
  "startConversation.user.not-found": "¡Mmm! Tu mensaje no debe exceder los 10,000 caracteres",
  "tab.discover": "Descubrir",
  "tab.error.generic-description": "Esta pestaña ha encontrado un error.",
  "tab.error.try-again": "Reintentar",
  "tab.messaging": "Mensajes",
  "tab.prayer-space": "Lugar de oración",
  "tag.not-found": "La etiqueta no ha sido encontrada",
  "thanks.prayed.watchman.intentions": "Gracias por tu fidelidad",
  "timeout-or-duplicate": "El captcha ha caducado o ya se ha utilizado. Por favor, vuelve a verificarlo.",
  "token.expired": "El token o clave de autenticación ha caducado. Comprueba que has utilizado el enlace que enviamos para cambiar tu contraseña antes de las últimas 48 horas.",
  "token.required": "Se requiere el token o la clave de autenticación",
  "uplift.answer.error": "Ha ocurrido un error. Tu respuesta no se ha enviado.",
  "uplift.message": "Mensaje de apoyo",
  "uplift.message.error": "Ocurrió un error. Tu mensaje de apoyo no fue enviado.",
  "uplift.textarea.placeholder.long": "Deja un mensaje de apoyo a {userName}...",
  "uplift.textarea.placeholder.short": "Escribe tu mensaje de apoyo...",
  "user.avatar.logo": "Mi logo",
  "user.communities": "Este usuario propone",
  "user.communities.other": "Voir todas las propuestas",
  "user.delivery-issue-email.alert-message": "Parece que hay un problema con su dirección de correo electrónico",
  "user.delivery-issue-email.hard-bounce-invalid": "<p>Parece que hay un problema con su dirección de correo electrónico. No logramos enviarle los correos que desea recibir de parte de Hozana 😅</p> <p>Por favor, verifique su dirección de correo electrónico.</p>",
  "user.delivery-issue-email.spam-report": "<p>Parece que su dirección de correo electrónico está marcando nuestros mensajes como \"Correo no deseado\" o \"SPAM\" 😞</p> <p>Le invitamos a:<br/> • ir a su carpeta de correo no deseado y mover los últimos correos recibidos de Hozana a su bandeja de entrada,<br/> • luego agregar \"hola@hozana.org\" a sus contactos (o remitentes seguros).</p> <p>Si el problema persiste dentro de 3 días, por favor haga clic en el botón \"Informar de un problema\" a continuación.</p>",
  "user.delivery-issue-email.verify-email": "Verificar mi correo electrónico",
  "user.happy-birthday.psalm": "Tú creaste mis entrañas, me plasmaste en el seno de mi madre: te doy gracias porque fui formado de manera tan admirable […]",
  "user.happy-birthday.reference": "Salmo 139, 13-14",
  "user.happy-birthday.title": "¡Feliz cumpleaños,\n{username}!",
  "user.happy-birthday.users-pray-for-you": "¡Hoy, algunos usuarios oran por ti!",
  "user.happy-birthday.wish": "¡Feliz cumpleaños!",
  "user.home-location": "¿En qué ciudad vives?",
  "user.logout.word": "Desconectarse",
  "user.mail.unsubscribe": "Ya no recibirás correos electrónicos nuestros solicitando donaciones durante 1 año.",
  "user.not-found": "Este usuario no existe",
  "user.popins.avatars.choose-my-image": "Escoger mi imagen de perfil",
  "user.profile.done-communities": "Mi listados terminó",
  "user.profile.favorite-publications": "Publicaciones favoritas",
  "user.profile.my-profile": "Mi perfil",
  "user.profile.questions.title.wizard": "Y finalmente, para personalizar tu oración",
  "user.profile.questions.you-are": "Eres",
  "user.profile.questions.your-birthdate": "Para rezar por ti en tu cumpleaños, naciste el",
  "user.profile.questions.your-location": "Tu ciudad",
  "user.settings.click-to-fill": "Pulsar para escribir",
  "user.settings.tab.account.password-required": "Por favor ingresa tu contraseña para validación.",
  "user.title.brother": "Hermano",
  "user.title.deacon": "Diácono",
  "user.title.family": "Familia",
  "user.title.father": "Sacerdote",
  "user.title.miss": "Srta.",
  "user.title.mr": "Sr.",
  "user.title.mrs": "Sra.",
  "user.title.org": "Organización",
  "user.title.sister": "Hermana",
  "user.wizard.audio": "Audio",
  "user.wizard.complete": "Buscamos\nlo que podría interesarte...",
  "user.wizard.minutes": "min",
  "user.wizard.my-wizard": "Mis preferencias de oración",
  "user.wizard.novena": "Novena",
  "user.wizard.reading": "Lectura",
  "user.wizard.video": "Vídeo",
  "user.wizard.welcome.user": "¡Bienvenido {name}!",
  "user.wizard.what-themes": "¿Qué temas te interesan?",
  "user.wizard.what-topics": "¿Un tema te importa especialmente hoy?",
  "watchman.daily-counted.intentions": "{count, plural, one {Tu intención del día} other {Tus {count} intenciones del día}}",
  "watchman.daily.close": "¿Deseas dejar de orar?",
  "watchman.daily.continue": "Continuar orando",
  "watchman.daily.intentions": "Tus intenciones del día",
  "watchman.daily.pray-for-more": "Rezar por más intenciones",
  "watchman.daily.remaining": "Te {count, plural, one {queda {count} intención} other {quedan {count} intenciones}} para hoy",
  "watchman.intentions.choice": "Selección de intenciones",
  "watchman.intentions.explanation": "Las intenciones se eligen al azar entre aquellas que han recibido <strong>menos de 20 oraciones</strong>",
  "watchman.intentions.explanation.end": "Puedes modificar cada intención según tus preferencias, haciendo clic en el icono 🔄 junto a cada intención.",
  "watchman.pray-for-today": "Rezar por hoy",
  "watchman.prayers.thank-you": "Gracias por sus oraciones",
  "watchman.prayers.thanks-for": "Gracias por {name}",
  "watchman.push.description": "<strong>Activa las notificaciones</strong> para seguir mejor tu compromiso como Guardián de oración.",
  "watchman.push.details": "Podrás cambiar tus preferencias en cualquier momento.",
  "watchman.push.title": "Mantén tu compromiso,<br/>¡recibe un recordatorio!",
  "watchman.rely.remains": "{count, plural, one {Una persona todavía cuenta con tu oración} other {{count} personas todavía cuentan con tus oraciones}}",
  "watchman.three.intentions": "Reza por 3 intenciones cada día",
  "widget.not-found": "No se encontró el widget de \"intención\"",
  "wizard.communityFormats.unknown": "¡Vaya! Pequeño problema, la selección no funcionó",
  "wizard.communityTypes.unknown": "¡Vaya! Pequeño problema, la selección no funcionó",
  "wizard.prayerDuration.unknown": "¡Vaya! Pequeño problema, la selección no funcionó",
  "wizard.tags.unknown": "¡Vaya! Pequeño problema, la selección no funcionó",
  "word.all.feminine": "Todas",
  "word.cancel": "Cancelar",
  "word.characters": "{count, plural, =0 {No queda más espacio} one {1 espacio restante} other {{count} espacios restantes}}",
  "word.choose": "Seleccionar",
  "word.close": "Cerrar",
  "word.confirm": "Confirmar",
  "word.congratulations": "¡Muy bien!",
  "word.continue": "Seguir",
  "word.create.content": "Crear contenido",
  "word.days": "{count, plural, one {# día} other {# días}}",
  "word.edit": "Modificar",
  "word.email": "Email",
  "word.email-address": "Correo electrónico",
  "word.email-address-connection": "Correo electrónico de conexión",
  "word.email-address-notification": "Correo electrónico de notificación",
  "word.finish": "Terminar",
  "word.in": "en",
  "word.intentions": "Intenciones",
  "word.leave-message": "Registrar",
  "word.next": "Siguiente",
  "word.no": "No",
  "word.notifications": "Notificaciones",
  "word.notifications.mails": "Notificaciones y correos electrónicos",
  "word.prayers": "Oraciones",
  "word.prayers-count": "{count, plural, one {{count} oración} other {{count} oraciones}}",
  "word.previous": "Precedente",
  "word.remove": "Suprimir",
  "word.save": "Guardar",
  "word.send": "Enviar",
  "word.skip": "Omitir",
  "word.start": "Comenzar",
  "word.start-again": "Volver a comenzar",
  "word.stop": "Detener",
  "word.thank-you": "Gracias",
  "word.today": "Hoy",
  "word.validate": "Validar",
  "word.watchman": "Centinela de oración",
  "word.whats-next": "¿Qué quieres hacer ahora?",
  "word.yes": "Sí",
  "word.yesterday": "Ayer",
  "word.you": "Tú",
  "word.your-firstname": "Vuestro apellido",
  "word.your-title": "Tu civilidad",
  "wording.i-share": "Comparto",
  "words.a-man": "Un hombre",
  "words.a-woman": "Una mujer",
  "words.answer": "Responder",
  "words.by-user": "Por {userName}",
  "words.click-here": "Haga clic aquí",
  "words.contact-us": "Contáctenos",
  "words.daily": "A diario",
  "words.done": "¡Listo!",
  "words.has-prayed": "{contactName} hizo su oración",
  "words.hello.user": "Hola {userName},",
  "words.home-page": "Página de inicio",
  "words.i-check": "Verifico",
  "words.i-continue": "Continúo",
  "words.i-subscribe": "Me inscribo",
  "words.in-nb-days": "En {nbDays} {nbDays, plural, one {día} other {días}}",
  "words.in-nb-days-begin": "Comienza en {nbDays} {nbDays, plural, one {día} other {dias}}",
  "words.know-more": "Más información",
  "words.maybe-later": "Quizá más tarde",
  "words.nb-days": "{nbDays} {nbDays, plural, one {día} other {días}}",
  "words.no-thanks": "No, gracias",
  "words.no-thanks2": "no, gracias",
  "words.not-now": "Ahora no",
  "words.ongoing": "En este momento",
  "words.password.placeholder": "Tu contraseña",
  "words.profile": "Perfil",
  "words.see": "Ver",
  "words.see-all.plur-fem": "Verlas todas",
  "words.see-all.sing": "Ver todo",
  "words.sign-up": "Inscribirse",
  "words.terms-of-use": "Condiciones de uso",
  "words.thank": "Agradecer",
  "words.thank-you-very-much": "¡Muchas gracias! 😊",
  "words.thanked": "Agradecido",
  "words.you-prayed": "Has hecho tu oración",
  "words.your-email-address": "Tu dirección de correo electrónico",
  "words.your-intention": "Tu intención",
  "words.your-message": "Tu mensaje"
}
